// removed by extract-text-webpack-plugin
module.exports = {"message":"message__2Uupe","level_info":"level_info__3fOrw","level_warning":"level_warning__2wJqT","message_content":"message_content__1RTkA","message_icon":"message_icon__-L6vq","close_btn":"close_btn__3thh4"};


//////////////////
// WEBPACK FOOTER
// ./components/message/style.scss
// module id = lCuA
// module chunks = 13